module.exports = __webpack_public_path__ + "img/success-check-mark.672096dc.svg";